; (function (jQuery) {

	"use strict";

	function Menu() {
		var global = {
			navExpanded: false,
			desktopBreakpoint: 1000,
		};

		var fn = {
			init: function () {
				jQuery('.menu-toggle').on('click', fn.handleToggleBurgerMenu);
				jQuery('.primary-menu__submenu-toggle').on('click', fn.handleToggleSubmenu);
				fn.menuResetOnResize();
			},
			/**
			 * Reset the state of the menu when we change from desktop to mobile or vice versa
			 */
			menuResetOnResize: function () {
				var mediaQuery = window.matchMedia("(min-width: "+global.desktopBreakpoint+"px)");
				mediaQuery.addEventListener('change', function(){
					var mobileMenu = jQuery('.mobile-menu');
					var body = jQuery('body');
					var menuToggleButton = jQuery('.menu-toggle');
					var screenReaderText = jQuery('.menu-toggle .screen-reader-text');
					global.navExpanded = false;
					body.removeClass('mobile-menu-open');
					mobileMenu.removeClass('mobile-menu--open');
					menuToggleButton.attr('aria-expanded', 'false');
					menuToggleButton.removeClass('menu-toggle__menu-btn--active');
					jQuery('.primary-menu__item ').removeClass('submenu-open');
					screenReaderText.text('Menu');
				});
			},
			/**
			 * Make the chevron for sub-menus toggle a class to show/hide the submenu
			 * @param {*} e
			 */
			handleToggleSubmenu: function (e) {
				jQuery(this).parents('.primary-menu__item').toggleClass('submenu-open');
			},
			/**
			 * Controls behaviour of the burger toggle on mobile
			 *
			 * @param {*} e
			 */
			handleToggleBurgerMenu: function (e) {
				var mobileMenu = jQuery('.mobile-menu');
				var body = jQuery('body');
				var menuToggleButton = jQuery(this);
				var screenReaderText = jQuery('.menu-toggle .screen-reader-text');
				if (!global.navExpanded) {
					global.navExpanded = true;
					body.addClass('mobile-menu-open');
					mobileMenu.addClass('mobile-menu--open');
					menuToggleButton.attr('aria-expanded', 'true');
					menuToggleButton.addClass('menu-toggle__menu-btn--active');
					screenReaderText.text('Close menu');
				}
				else {
					global.navExpanded = false;
					body.removeClass('mobile-menu-open');
					mobileMenu.removeClass('mobile-menu--open');
					menuToggleButton.attr('aria-expanded', 'false');
					menuToggleButton.removeClass('menu-toggle__menu-btn--active');
					screenReaderText.text('Menu');
				}
			},
		}

		jQuery(fn.init);
	}

	new Menu();
})(jQuery);